import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import type { ModuleDefinition } from '../../app/moduleRegistry';
import type { CurrentUser } from '../../api/types/auth';
import TicketSalesReportPage from './pages/TicketSalesReportPage';
import PersonnelSalesReportPage from './pages/PersonnelSalesReportPage';

/** Legacy `ReportController` — GSA staff (master GSA / B2E), not CORPORATE. */
const isVisible = (user: CurrentUser | null) =>
  (!!user?.isMasterGsa || user?.userType === 'B2E') && user?.gsaType !== 'CORPORATE';

export const reportsModule: ModuleDefinition = {
  routes: [
    { path: 'reports/ticket-sales', element: <TicketSalesReportPage /> },
    { path: 'reports/personnel-sales', element: <PersonnelSalesReportPage /> },
  ],
  menuItems: [
    {
      label: 'Bilet Satış Raporu',
      path: 'reports/ticket-sales',
      icon: <ConfirmationNumberOutlinedIcon />,
      group: 'Raporlar',
      groupIcon: <AssessmentOutlinedIcon />,
      isVisible,
    },
    {
      label: 'Personel Satış Raporu',
      path: 'reports/personnel-sales',
      icon: <GroupsOutlinedIcon />,
      group: 'Raporlar',
      isVisible,
    },
  ],
};
